module.exports = __webpack_public_path__ + "static/img/aveva-logo.c7f2346.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/aveva-logo.png
// module id = YV52
// module chunks = 0